.demoForm {
  --primary-color: #154dd1;
  --primary-border-color: #154dd1;
  --primary-text-color: #fff;
  --primary-hover-color: #193f99;
  --primary-hover-border-color: #193f99;
  --primary-hover-text-color: #fff;
  --primary-background-input-field-color: #e6eff6;
  --primary-placeholder-color: #9fa9bc;
  --primary-border-focus-color: #075da7;
  --primary-cta-color: #e30613;

  --secondary-color: #154dd1;
  --secondary-border-color: #e6eff6;
  --secondary-text-color: #002b4d;
  --secondary-hover-color: #193f99;
  --secondary-hover-border-color: #193f99;
  --secondary-hover-text-color: #fff;

  font-size: 16px;
  padding: 0 32px 40px 32px;
  background-color: var(--primary-text-color);
  border-radius: 8px;
  opacity: 1;
  transition: all 0.2s linear;
}

b {
  font-family: "CornerDisplayBolder", sans-serif;
  color: var(--primary-border-focus-color);
}

.action {
  flex: 1 1 50%;
  position: relative;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  font-family: "CornerDisplay", sans-serif;
  color: var(--form-text-color);
}

.demoTitle {
  text-align: left;
  font-size: 30px;
  line-height: 1.2;
  margin: 32px 0 24px 0;
  color: var(--secondary-text-color);
  text-transform: uppercase;
}

div.customFieldRow {
  margin: 0 -6px;
  display: flex;
  flex-direction: column;
}

div.customPhoneInput > div,
div.customPhoneInput > div > input[type="text"] {
  width: 80px !important;
}

div.customPhoneInput,
div.customInput {
  border: none;
  border-radius: 8px;
  background-color: var(--primary-background-input-field-color);
}

div.customPhoneInput > div > div > div > div,
div.customInput > div > div > div {
  font-family: "Inter", sans-serif;
}

div.customPhoneInput > div > div > div > div:hover,
div.customInput > div > div > div:hover {
  color: var(--secondary-color) !important;
}

div.customPhoneInput > input::placeholder,
div.customInput > input::placeholder {
  color: var(--primary-placeholder-color);
}

div.customPhoneInput > input:focus::placeholder,
div.customInput > input:focus::placeholder {
  opacity: 0;
}

div.customPhoneInput:focus-within,
div.customInput:focus-within {
  border: solid 2px var(--secondary-border-color);
  background-color: var(--primary-hover-text-color);
}

div.customPhoneInput > div > input,
div.customInput > input,
div.customInput > input[type="text"] {
  color: var(--secondary-text-color);
}

label.customLabel {
  display: block;
  margin-bottom: 8px;
  font-weight: 700;
  color: var(--secondary-text-color);
  font-size: 12px;
  font-family: "CornerDisplayBolder", sans-serif;
  text-transform: uppercase;
}

label.customLabel:has(+ .customPhoneInput:focus-within),
label.customLabel:has(+ .customInput:focus-within) {
  color: var(--primary-border-focus-color);
}

div.customPhoneInput > div > i,
div.customInput > i {
  display: none;
  color: var(--form-arrow-color) !important;
  font-size: 16px !important;
}

.disclaimerButton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: inline;
  margin: 0;
  padding: 0;
  font-size: 14px;
  color: var(--secondary-text-color);
  font-family: "Inter", sans-serif;
}

.disclaimer {
  font-size: 14px;
  line-height: 1.33;
  font-weight: 400;
  color: var(--secondary-text-color);
  font-family: "Inter", sans-serif;
}

div.disclaimerRow {
  flex-direction: row;
}

.disclaimer i {
  margin-left: 0.5rem;
  padding-top: 1rem;
  cursor: pointer;
  color: var(--secondary-text-color);
}

.disclaimerCheckBox {
  max-width: fit-content;
  margin-right: 0rem;
}

.disclaimerCheckBox > div > div > label span {
  border-radius: 25%;
  border: solid 1px var(--primary-border-focus-color) !important;
}

.expContent {
  font-size: 12px;
  line-height: 1.33;
  padding-top: 10px;
}

.expContent ul {
  margin-top: 8px;
  list-style-type: disc;
}

.expContent li {
  margin-left: 16px;
}

.expContent a {
  color: var(--secondary-color-palette);
  font-size: 12px;
}

.cta {
  margin-top: 12px;
  text-align: left;
  width: 119px;
}

.demoForm .cta button {
  text-transform: uppercase;
  min-width: 150px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
  padding: 6px 16px;
  font-family: "CornerDisplay", sans-serif;
  border: solid 2px var(--primary-cta-color) !important;
  background-color: var(--primary-cta-color) !important;
  border-radius: 8px;
}

.errorSubmit {
  color: var(--form-text-error-color);
  display: block;
  margin-top: 20px;
}

div.containerError {
  text-align: center;
}

.ccLink {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.33;
  font-weight: 400;
  color: var(--secondary-text-color);
  font-family: "Inter", sans-serif;
  margin: 24px 0 0 0 !important;
}

.ccLink a,
.ccLink a:hover,
.ccLink a:visited,
.ccLink a:active,
.ccLink a:focus {
  color: var(--secondary-text-color);
  text-decoration: underline;
  outline: none;
  font-weight: unset;
  font-size: unset;
  line-height: unset;
}

@media screen and (max-width: 768px) {
  div.customFieldRow {
    padding-top: 6px;
  }
}

@media screen and (min-width: 769px) {
  .demoTitle {
    font-size: 32px;
    text-align: left;
  }

  div.customFieldRow {
    flex-direction: row !important;
    align-items: center;
  }
}

@media screen and (min-width: 993px) {
  .action {
    display: block;
  }

  .demoTitle {
    font-size: 40px;
  }
}

@media screen and (min-width: 1280px) {
  .action {
    flex: 1 0 600px;
  }
}
